import * as actionTypes from './engagements.types.js';
import { getEngagement, patchEngagement } from './engagements.resource.js';
import { catchAsyncStacktrace } from 'auto-trace';

export function updateEngagement(engagement) {
  return {
    type: actionTypes.NEW_ENGAGEMENT,
    engagement: engagement
  };
}

export function fetchEngagement(clientId, engagementId, next) {
  return dispatch => {
    getEngagement(clientId, engagementId).subscribe(
      engagement => {
        dispatch(updateEngagement(engagement));
        if (next) next(engagement);
      },
      err => catchAsyncStacktrace(err)
    );
  };
}

export function consumeCollectionCase({ clientId, engagementId, next }) {
  return dispatch => {
    const data = {
      collection_case_consumed: true
    };

    patchEngagement({ clientId, engagementId, data }).subscribe(engagement => {
      dispatch(updateEngagement(engagement));
      if (next) next(engagement);
    }, catchAsyncStacktrace());
  };
}

export function resetEngagement() {
  return {
    type: actionTypes.RESET_ENGAGEMENT
  };
}
